// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".player-container{height:100%;width:100%;display:flex;justify-content:center;align-items:center}.player{width:100%;padding:20px;max-height:100%!important}.player,.player .youtube-player__video-container{height:100%}.sponsored-wrapper{text-align:initial;height:100%;width:65%;margin:0 auto}@media(min-width:1024px){.sponsored-wrapper{max-width:70%}}", ""]);
// Exports
module.exports = exports;
